import { atomWithStorage, createJSONStorage } from "jotai/utils";
import { Storage } from "./storage";

export const atomWithLocalStorage = <T>(key: string, initialValue: T) => {
  const jsonStorage = createJSONStorage<T>(() => ({
    getItem: (key: string): string | null => {
      return Storage.getString(key) || null; // Directly return the string or null
    },
    setItem: (key: string, value: string): void => {
      Storage.setString(key, value); // Assume value is already a string
    },
    removeItem: (key: string) => {
      Storage.delete(key);
    },
  }));
  return atomWithStorage(key, initialValue, jsonStorage);
};
